module.exports = __webpack_public_path__ + "img/archive.8afaf01b.svg";